import { render, staticRenderFns } from "./ResearchReportTextListItem.vue?vue&type=template&id=37703703&scoped=true"
import script from "./ResearchReportTextListItem.vue?vue&type=script&lang=js"
export * from "./ResearchReportTextListItem.vue?vue&type=script&lang=js"
import style0 from "./ResearchReportTextListItem.vue?vue&type=style&index=0&id=37703703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37703703",
  null
  
)

export default component.exports